<ng-container *transloco="let t; read: 'companies'">
  @if (vm$ | async; as vm) {
    <div class="componentContainer">
      <section class="xs12col componentHeader">
        <h1>{{t('title')}}</h1>
      </section>
      <section class="oneCol">
        <div class="xs12col">
          <div class="boxContainer">
            <div class="box">
              <kendo-grid
                [data]="companies$ | async"
                [resizable]="true"
                (add)="addHandler($event)"
                (save)="saveHandler($event)"
                (cancel)="cancelHandler($event)"
                [skip]="vm.gridState.skip"
                [pageSize]="vm.gridState.pageSize"
                [pageable]="true"
                [loading]="loading"
                (pageChange)="pageChangeSub$.next($event)">
                <ng-template kendoGridToolbarTemplate>
                  <a kendoGridAddCommand class="addIcon" [hidden]="!('Permissions.Companies.Create' | permission)">
                    <span class="icon">
                      <img src="../../../assets/icons/add-icon.svg">
                    </span>
                    {{t('add')}}
                  </a>
                </ng-template>
                <kendo-grid-column field="name" [title]="t('companyName')" media="(min-width: 993px)">
                  <ng-template
                    kendoGridEditTemplate
                    let-isNew="isNew"
                    let-formGroup="formGroup"
                    >
                    <kendo-textbox
                      [formControl]="formGroup.get('name')"
                    ></kendo-textbox>
                    @if (formGroup.get('name').hasError('required') && formGroup.get('name').touched) {
                      <kendo-formerror
                      >{{t('isRequired')}}</kendo-formerror>
                    }
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="tenantId" [title]="t('tenantId')" media="(min-width: 993px)">
                  <ng-template
                    kendoGridEditTemplate
                    let-isNew="isNew"
                    let-formGroup="formGroup"
                    >
                    <kendo-textbox
                      [formControl]="formGroup.get('tenantId')"
                    ></kendo-textbox>
                    @if (formGroup.get('tenantId').hasError('companyTenantIdExists')) {
                      <kendo-formerror
                      >{{t('companyTenantIdAlreadyExists')}}</kendo-formerror>
                    }
                    @if (formGroup.get('tenantId').hasError('required') && formGroup.get('tenantId').touched) {
                      <kendo-formerror
                      >{{t('isRequired')}}</kendo-formerror>
                    }
                    @if (formGroup.get('tenantId').hasError('pattern') && formGroup.get('tenantId').touched) {
                      <kendo-formerror
                      >{{t('companyTenantIdCannotContainUmlaute')}}</kendo-formerror>
                    }
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="internalNumber" [title]="t('internalNumber')" media="(min-width: 993px)">
                  <ng-template
                    kendoGridEditTemplate
                    let-isNew="isNew"
                    let-formGroup="formGroup"
                    >
                    <kendo-textbox
                      [formControl]="formGroup.get('internalNumber')"
                    ></kendo-textbox>
                    @if (formGroup.get('internalNumber').hasError('companyInternalNumberExists')) {
                      <kendo-formerror
                      >{{t('companyInternalNumberExists')}}</kendo-formerror>
                    }
                    @if (formGroup.get('internalNumber').hasError('required') && formGroup.get('internalNumber').touched) {
                      <kendo-formerror
                      >{{t('isRequired')}}</kendo-formerror>
                    }
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderCopyEmail" media="(min-width: 993px)">
                  <ng-template kendoGridHeaderTemplate>
                    <span  class="tooltipContainer">
                      {{t('orderCopyEmail')}}
                      <span [attr.tooltip]="t('tooltipEmail')" flow="right" class="tooltipContainer">
                        <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                      </span>
                    </span>
                  </ng-template>
                  <ng-template
                    kendoGridEditTemplate
                    let-isNew="isNew"
                    let-formGroup="formGroup"
                    >
                    <kendo-textbox
                      [formControl]="formGroup.get('orderCopyEmail')"
                    ></kendo-textbox>
                    @if (formGroup.get('orderCopyEmail').hasError('email')) {
                      <kendo-formerror
                      >{{t('emailWrongFormat')}}</kendo-formerror>
                    }
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-command-column media="(min-width: 993px)">
                  <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
                    @if (!isNew) {
                      <a [routerLink]="['/companies', dataItem.id]"
                        [attr.tooltip]="t('open')"
                        flow="up"
                        class="actionIcon">
                        <img src="../../../assets/icons/open-link-icon.svg">
                      </a>
                      <a (click)="onDelete(dataItem)"
                        [attr.tooltip]="t('delete')"
                        flow="up"
                        [hidden]="!('Permissions.Companies.Delete' | permission)"
                        class="actionIcon">
                        <img src="../../../assets/icons/delete-icon.svg">
                      </a>
                    }
                    <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                      {{t('add')}}
                    </button>
                    <button kendoGridCancelCommand> {{t('cancel')}}</button>
                  </ng-template>
                </kendo-grid-command-column>
                <!-- MOBILE GRID -->
                <kendo-grid-column-group media="(max-width: 992px)">
                  <kendo-grid-column>
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <h4 class="mobileGridHeader">{{t('companyName')}}</h4>
                      <span>{{dataItem.name}}</span>
                    </ng-template>
                    <ng-template
                      kendoGridEditTemplate
                      let-isNew="isNew"
                      let-formGroup="formGroup">
                      <h4 class="mobileGridHeader">{{t('companyName')}}</h4>
                      <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
                      @if (formGroup.get('name').hasError('required') && formGroup.get('name').touched) {
                        <kendo-formerror>
                          {{t('isRequired')}}
                        </kendo-formerror>
                      }
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column>
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <h4 class="mobileGridHeader">{{t('tenantId')}}</h4>
                      <span>{{dataItem.tenantId}}</span>
                    </ng-template>
                    <ng-template
                      kendoGridEditTemplate
                      let-isNew="isNew"
                      let-formGroup="formGroup">
                      <h4 class="mobileGridHeader">{{t('tenantId')}}</h4>
                      <kendo-textbox [formControl]="formGroup.get('tenantId')"></kendo-textbox>
                      @if (formGroup.get('tenantId').hasError('companyTenantIdExists')) {
                        <kendo-formerror>
                          {{t('companyTenantIdAlreadyExists')}}
                        </kendo-formerror>
                      }
                      @if (formGroup.get('tenantId').hasError('required') && formGroup.get('tenantId').touched) {
                        <kendo-formerror
                        >{{t('isRequired')}}</kendo-formerror>
                      }
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column>
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <h4 class="mobileGridHeader">{{t('internalNumber')}}</h4>
                      <span>{{dataItem.internalNumber}}</span>
                    </ng-template>
                    <ng-template
                      kendoGridEditTemplate
                      let-isNew="isNew"
                      let-formGroup="formGroup">
                      <h4 class="mobileGridHeader">{{t('tenantId')}}</h4>
                      <kendo-textbox [formControl]="formGroup.get('internalNumber')"></kendo-textbox>
                      @if (formGroup.get('internalNumber').hasError('companyInternalNumberExists')) {
                        <kendo-formerror>
                          {{t('companyInternalNumberExists')}}
                        </kendo-formerror>
                      }
                      @if (formGroup.get('internalNumber').hasError('required') && formGroup.get('internalNumber').touched) {
                        <kendo-formerror>
                          {{t('isRequired')}}
                        </kendo-formerror>
                      }
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="orderCopyEmail">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <h4 class="mobileGridHeader">{{t('orderCopyEmail')}}</h4>
                      <span>{{dataItem.orderCopyEmail}}</span>
                    </ng-template>
                    <ng-template kendoGridHeaderTemplate>
                      <span  class="tooltipContainer">
                        {{t('orderCopyEmail')}}
                        <span [attr.tooltip]="t('tooltipEmail')" flow="right" class="tooltipContainer">
                          <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                        </span>
                      </span>
                    </ng-template>
                    <ng-template
                      kendoGridEditTemplate
                      let-isNew="isNew"
                      let-formGroup="formGroup">
                      <h4 class="mobileGridHeader">{{t('orderCopyEmail')}}</h4>
                      <kendo-textbox [formControl]="formGroup.get('orderCopyEmail')"></kendo-textbox>
                      @if (formGroup.get('orderCopyEmail').hasError('email')) {
                        <kendo-formerror>
                          {{t('emailWrongFormat')}}
                        </kendo-formerror>
                      }
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-command-column>
                    <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
                      @if (!isNew) {
                        <a [routerLink]="['/companies', dataItem.id]"
                          [attr.tooltip]="t('edit')"
                          flow="up"
                          class="actionIcon">
                          <img src="../../../assets/icons/edit-icon.svg">
                        </a>
                        <a (click)="onDelete(dataItem)"
                          [attr.tooltip]="t('delete')"
                          flow="up"
                          class="actionIcon">
                          <img src="../../../assets/icons/delete-icon.svg">
                        </a>
                      }
                      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                        {{t('add')}}
                      </button>
                      <button kendoGridCancelCommand> {{t('cancel')}}</button>
                    </ng-template>
                  </kendo-grid-command-column>
                </kendo-grid-column-group>
                <!-- Paging -->
                <ng-template
                  let-totalPages="totalPages"
                  let-currentPage="currentPage"
                  kendoPagerTemplate>
                  <div class="flex gridPagination">
                    <div class="flex flexDirRow gridRow">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-numeric-buttons
                        [buttonCount]="5"
                      ></kendo-pager-numeric-buttons>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                    <div class="gridRow">
                      <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
                        <button
                        (click)="pageChangeSub$.next({
                          skip: vm.gridState.skip,
                          take: pageSizes.Small
                        })"
                          kendoButton
                          [selected]="vm.gridState.pageSize === pageSizes.Small"
                          [toggleable]="true"
                          >
                          {{ pageSizes.Small }}
                        </button>
                        <button
                        (click)="pageChangeSub$.next({
                          skip: vm.gridState.skip,
                          take: pageSizes.Medium
                        })"
                          kendoButton
                          [selected]="vm.gridState.pageSize === pageSizes.Medium"
                          [toggleable]="true"
                          >
                          {{ pageSizes.Medium }}
                        </button>
                        <button
                        (click)="pageChangeSub$.next({
                          skip: vm.gridState.skip,
                          take: pageSizes.Large
                        })"
                          kendoButton
                          [selected]="vm.gridState.pageSize === pageSizes.Large"
                          [toggleable]="true"
                          >
                          {{ pageSizes.Large }}
                        </button>
                      </kendo-buttongroup>
                      @if (reloadResults) {
                        <button
                          kendoButton
                          [title]="t('refresh')"
                          class="reloadIcon"
                          (click)="searchRequest$.next(vm.searchRequest)">
                          <img class="actionIcon" src="../assets/icons/reload.svg">
                        </button>
                      }
                    </div>
                  </div>
                </ng-template>
                <ng-template kendoGridLoadingTemplate>
                  <div class="k-loading-color"></div>
                  <div class="loading-container">
                    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                  </div>
                </ng-template>
              </kendo-grid>
            </div>
          </div>
        </div>
      </section>
    </div>
  }
</ng-container>
